import allen__asset from "./allen.jpg.asset.json";
import arlington__asset from "./arlington.jpg.asset.json";
import atlanta__asset from "./atlanta.jpg.asset.json";
import austin__asset from "./austin.jpg.asset.json";
import baltimore__asset from "./baltimore.jpg.asset.json";
import beverly_hills__asset from "./beverly-hills.jpg.asset.json";
import boca_raton__asset from "./boca-raton.jpg.asset.json";
import boston__asset from "./boston.jpg.asset.json";
import boulder__asset from "./boulder.jpg.asset.json";
import brooklyn_heights__asset from "./brooklyn-heights.jpg.asset.json";
import charlotte__asset from "./charlotte.jpg.asset.json";
import chicago_fulton_market__asset from "./chicago-fulton-market.jpg.asset.json";
import chicago_hancock__asset from "./chicago-hancock.jpg.asset.json";
import chicago_lincoln_park__asset from "./chicago-lincoln-park.jpg.asset.json";
import cincinnati__asset from "./cincinnati.jpg.asset.json";
import colorado_springs__asset from "./colorado-springs.jpg.asset.json";
import columbus__asset from "./columbus.jpg.asset.json";
import cornelius__asset from "./cornelius.jpg.asset.json";
import dallas_highland_park__asset from "./dallas-highland-park.jpg.asset.json";
import dallas_plano__asset from "./dallas-plano.jpg.asset.json";
import deerfield__asset from "./deerfield.jpg.asset.json";
import downtown_denver__asset from "./downtown-denver.jpg.asset.json";
import edina__asset from "./edina.jpg.asset.json";
import fort_worth__asset from "./fort-worth.jpg.asset.json";
import fulton_market__asset from "./fulton-market.jpg.asset.json";
import greenwood_village__asset from "./greenwood-village.jpg.asset.json";
import hancock__asset from "./hancock.jpg.asset.json";
import henderson__asset from "./henderson.jpg.asset.json";
import houston__asset from "./houston.jpg.asset.json";
import independence__asset from "./independence.jpg.asset.json";
import indianapolis__asset from "./indianapolis.jpg.asset.json";
import jacksonville__asset from "./jacksonville.jpg.asset.json";
import kansas_city__asset from "./kansas-city.jpg.asset.json";
import lake_forest__asset from "./lake-forest.jpg.asset.json";
import las_vegas__asset from "./las-vegas.jpg.asset.json";
import lincoln_park__asset from "./lincoln-park.jpg.asset.json";
import manhasset__asset from "./manhasset.jpg.asset.json";
import manhattan__asset from "./manhattan.jpg.asset.json";
import melville__asset from "./melville.jpg.asset.json";
import miami__asset from "./miami.jpg.asset.json";
import milwaukee__asset from "./milwaukee.jpg.asset.json";
import nashville__asset from "./nashville.jpg.asset.json";
import nassau_county__asset from "./nassau-county.jpg.asset.json";
import nassau__asset from "./nassau.jpg.asset.json";
import neptune__asset from "./neptune.jpg.asset.json";
import new_orleans__asset from "./new-orleans.jpg.asset.json";
import newark__asset from "./newark.jpg.asset.json";
import newport_beach__asset from "./newport-beach.jpg.asset.json";
import novi__asset from "./novi.jpg.asset.json";
import oak_brook__asset from "./oak-brook.jpg.asset.json";
import oklahoma_city__asset from "./oklahoma-city.jpg.asset.json";
import orland_park__asset from "./orland-park.jpg.asset.json";
import paramus__asset from "./paramus.jpg.asset.json";
import philadelphia__asset from "./philadelphia.jpg.asset.json";
import phoenix__asset from "./phoenix.jpg.asset.json";
import pittsburgh__asset from "./pittsburgh.jpg.asset.json";
import portland__asset from "./portland.jpg.asset.json";
import queens__asset from "./queens.jpg.asset.json";
import raleigh__asset from "./raleigh.jpg.asset.json";
import salt_lake_city__asset from "./salt-lake-city.jpg.asset.json";
import san_antonio__asset from "./san-antonio.jpg.asset.json";
import san_diego__asset from "./san-diego.jpg.asset.json";
import san_francisco__asset from "./san-francisco.jpg.asset.json";
import schaumburg__asset from "./schaumburg.jpg.asset.json";
import scottsdale__asset from "./scottsdale.jpg.asset.json";
import south_lake__asset from "./south-lake.jpg.asset.json";
import st_charles__asset from "./st-charles.jpg.asset.json";
import st_louis__asset from "./st-louis.jpg.asset.json";
import tampa__asset from "./tampa.jpg.asset.json";
import virginia_beach__asset from "./virginia-beach.jpg.asset.json";
import washington_dc__asset from "./washington-dc.jpg.asset.json";
import white_plains__asset from "./white-plains.jpg.asset.json";

export const LOCATION_IMAGES: Record<string, string> = {
  "allen": allen__asset.url,
  "arlington": arlington__asset.url,
  "atlanta": atlanta__asset.url,
  "austin": austin__asset.url,
  "baltimore": baltimore__asset.url,
  "beverly-hills": beverly_hills__asset.url,
  "boca-raton": boca_raton__asset.url,
  "boston": boston__asset.url,
  "boulder": boulder__asset.url,
  "brooklyn-heights": brooklyn_heights__asset.url,
  "charlotte": charlotte__asset.url,
  "chicago-fulton-market": chicago_fulton_market__asset.url,
  "chicago-hancock": chicago_hancock__asset.url,
  "chicago-lincoln-park": chicago_lincoln_park__asset.url,
  "cincinnati": cincinnati__asset.url,
  "colorado-springs": colorado_springs__asset.url,
  "columbus": columbus__asset.url,
  "cornelius": cornelius__asset.url,
  "dallas-highland-park": dallas_highland_park__asset.url,
  "dallas-plano": dallas_plano__asset.url,
  "deerfield": deerfield__asset.url,
  "downtown-denver": downtown_denver__asset.url,
  "edina": edina__asset.url,
  "fort-worth": fort_worth__asset.url,
  "fulton-market": fulton_market__asset.url,
  "greenwood-village": greenwood_village__asset.url,
  "hancock": hancock__asset.url,
  "henderson": henderson__asset.url,
  "houston": houston__asset.url,
  "independence": independence__asset.url,
  "indianapolis": indianapolis__asset.url,
  "jacksonville": jacksonville__asset.url,
  "kansas-city": kansas_city__asset.url,
  "lake-forest": lake_forest__asset.url,
  "las-vegas": las_vegas__asset.url,
  "lincoln-park": lincoln_park__asset.url,
  "manhasset": manhasset__asset.url,
  "manhattan": manhattan__asset.url,
  "melville": melville__asset.url,
  "miami": miami__asset.url,
  "milwaukee": milwaukee__asset.url,
  "nashville": nashville__asset.url,
  "nassau-county": nassau_county__asset.url,
  "nassau": nassau__asset.url,
  "neptune": neptune__asset.url,
  "new-orleans": new_orleans__asset.url,
  "newark": newark__asset.url,
  "newport-beach": newport_beach__asset.url,
  "novi": novi__asset.url,
  "oak-brook": oak_brook__asset.url,
  "oklahoma-city": oklahoma_city__asset.url,
  "orland-park": orland_park__asset.url,
  "paramus": paramus__asset.url,
  "philadelphia": philadelphia__asset.url,
  "phoenix": phoenix__asset.url,
  "pittsburgh": pittsburgh__asset.url,
  "portland": portland__asset.url,
  "queens": queens__asset.url,
  "raleigh": raleigh__asset.url,
  "salt-lake-city": salt_lake_city__asset.url,
  "san-antonio": san_antonio__asset.url,
  "san-diego": san_diego__asset.url,
  "san-francisco": san_francisco__asset.url,
  "schaumburg": schaumburg__asset.url,
  "scottsdale": scottsdale__asset.url,
  "south-lake": south_lake__asset.url,
  "st-charles": st_charles__asset.url,
  "st-louis": st_louis__asset.url,
  "tampa": tampa__asset.url,
  "virginia-beach": virginia_beach__asset.url,
  "washington-dc": washington_dc__asset.url,
  "white-plains": white_plains__asset.url,
};
